<template>
  <el-container>
    <el-main>
      <el-form ref="form" label-width="80px">
        <div v-for="(item, index) in workList" :key="index">
          <el-divider content-position="left">工作经历 {{index+1}}</el-divider>
          <el-form-item label="公司名称">
            <el-input @change="change($event, item, index)" v-model="item.company_name"></el-input>
          </el-form-item>
          <el-form-item label="公司职位">
            <el-input @change="change($event, item, index)" v-model="item.position"></el-input>
          </el-form-item>
          <el-form-item label="主要工作">
            <el-input @change="change($event, item, index)" v-model="item.main_work"></el-input>
          </el-form-item>
          <el-form-item label="工作时间">
            <el-date-picker
              @blur="change($event, item, index)"
              v-model="item.date"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="addWork" icon="el-icon-plus">添加工作经历</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import $http from "../../../request.js";
import _ from "lodash";
export default {
  name: "work",
  created(){
    this.updateWorkList(this.list);
  },
  computed:{
    ...mapState([
      "defaultInfo",
      "area"
    ])
  },
  props:{
    list:{
      type: Array,
      default:function(){
        return [];
      }
    }
  },
  watch:{
    list(list){
      this.updateWorkList(list);
    }
  },
  data(){
    return {
      workList: [
        {
          work: "",
          date: "",
          education: "",
          profession: ""
        }
      ]
    };
  },
  methods:{
    updateWorkList(list){
      this.workList = list.map(v=>{
        v.date = [
          v.start_date,
          v.end_date
        ];
        return v;
      });
    },
    addWork(){
      this.workList = [
        ...this.workList,
        {
          work: "",
          date: "",
          education: "",
          profession: ""
        }
      ]
    },
    updateWork(params) {
      let url = "/api/member/member_work_experience/add";
      if(params.id) {
        url = "/api/member/member_work_experience/edit";
      }
      $http.post(url, params)
        .then(res=>{
          if (res.data.code===1){
            this.$message({
              message: params.id?"修改成功":"新增成功",
              type: 'success'
            });
            this.$emit('success');
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        });
    },
    focus(index){
      this.activeIndex = index;
    },
    change(e, item, index) {
      this.workList[index] = item;
      const params = {
        id: item.id||'',
        company_name: item.company_name,
        start_date: item.date[0],
        end_date: item.date[1],
        position: item.position,
        main_work: item.main_work
      }
      let toupdate = true;
      _.forIn(params, (val, key)=>{
        if (!val&&key!=='id') {
          toupdate = false;
        }
        if (val=="") {
          delete params[key];
        }
      });
      if (toupdate) {
        this.updateWork(params);
      }
    }
  }
};
</script>

<style lang="less">
  
</style>

